import { Fragment, FunctionComponent, ReactElement } from 'react';

export interface ConditionalChildrenProps {
    condition: (() => boolean) | boolean;
    fallback?: ReactElement;
}

const ConditionalChildren: FunctionComponent<ConditionalChildrenProps> = ({ condition, fallback, children }): ReactElement | null => {
    const conditionResult = typeof condition === 'boolean' ? condition : condition();

    if (true === conditionResult) {
        return <Fragment>{children}</Fragment>;
    }

    if (undefined !== fallback) {
        return fallback;
    }

    return null;
};

export default ConditionalChildren;
